import {
  type FC
} from 'react';
import {
  Modal,
  Stack,
  IconButton,
  ModalDialog,
} from '@mui/joy';
import {
  CloseIcon,
} from '@shared/ui';
import {
  type CoinPackage,
} from '@entities/coins';
import {
  SuccessConfirmationMessage
} from './success-confirmation-message.component';
import {
  LimitedCoinPackageList
} from './limited-coin-package-list.component';

export type WelcomeOfferModalProps = {
  coinPackages: CoinPackage[];
  loading?: boolean;
  onClose?: () => void;
  onPurchaseSelection: (coinPackage: CoinPackage) => void;
};

export const WelcomeOfferModal: FC<WelcomeOfferModalProps> = ({
  onClose,
  coinPackages,
  loading,
  onPurchaseSelection
}) => {
  return (
    <Modal open onClose={onClose}>
      <ModalDialog
        sx={{
          gap: 2,
          width: '100%',
          maxWidth: 360,
          overflow: 'hidden',
        }}>
        <Stack
          px={2}
          py={3}
          overflow='auto'
          alignItems='center'
          flexDirection='column'
          justifyContent='flex-start'
          position='relative'>
          <IconButton
            onClick={onClose}
            size='sm'
            sx={{
              top: 8,
              right: 8,
              position: 'absolute',
              width: 'fit-content',
            }}>
            <CloseIcon
              sx={({ palette }) => ({
                fontSize: 24,
                color: palette.common[200],
              })}
            />
          </IconButton>
          <Stack
            alignItems='center'
            flexDirection='column'
            justifyContent='flex-start'
            sx={({ palette }) => ({
              gap: 3,
              width: '100%',
              borderRadius: 12,
              height: 'fit-content',
              backgroundColor: palette.common[475],
            })}>
            <SuccessConfirmationMessage />
            <LimitedCoinPackageList
              loading={loading}
              items={coinPackages}
              onPurchaseSelection={onPurchaseSelection}
            />
          </Stack>
        </Stack >
      </ModalDialog>
    </Modal>
  );
};

